<template>
    <div class="freightGroup">
        <CartItem v-for="(item, key) in group.items" :key="key" :item="item" class="cartItem"/>
        <div class="delivery_items col-12">
            <div class="row">
                <div class="col-6 col-md-4">
                    <div class="heading">Delivery</div>
                    <select v-model="groupDelivery" class="select-css" :class="group.settings.delivery=='' ? 'default' : ''" ref="delivery_select">
                        <option disabled selected value class="select"> -- Select an Option -- </option>
                        <option v-for="option in deliveryOptions" :key="option.value" :value="option.value">{{option.name}}</option>
                    </select>
                </div>
                <div class="col-6 col-md-4">
                    <div v-if="canOptimise">
                        <label>Optimise Freight
                          <MoreInfoPopover width='300px'>
                            <p>Combine with other purchasers to meet the suppliers minimum order for freight free.</p>
                            <p>That means you will have to wait until the minimum order is reached before your order is placed.</p>
                          </MoreInfoPopover>
                        </label>
                        <input class="optimisecb" type="checkbox" v-model="groupOptimise"/>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2 my-md-0">
                    <div v-if="group.freight.messages">
                        <div class="freight_message" v-for="message in group.freight.messages" :key="message">{{message}}</div>
                    </div>
                    <div class="my-2" v-if="group.freight && !group.freight.combinable && $store.state.auth.memberLevel != 'silver'">
                        <div><span class="heading">Freight Cost:</span> {{CurrencyFormatter(group.freight.total)}}</div>
                    </div>
                </div>
                <div class="col-12" v-if="deliveryInfo">
                  <div class="my-2 heading">Pickup Information</div>
                  <!-- Only really happens when there is information associated with delivery option. Which is when supplier pickup address is selected -->
                  <p>
                    {{deliveryInfo}}
                  </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartItem from "./CartItem";

import { CurrencyFormatter } from "@/utils";

import MoreInfoPopover from "@/components/MoreInfoPopover"

export default {
  name: "CartGroup",
  components: {
    CartItem,
    MoreInfoPopover
  },
  props: ["group", "groupKey"],
  methods: {
    CurrencyFormatter,
    setValues(){
        this.groupDelivery = this.group.settings.delivery;
        this.groupOptimise = this.group.settings.optimise;
    }
  },
  created(){
      this.setValues();
  },
  data(){
      return{
          groupDelivery: null,
          groupOptimise: null
      }
  },
  computed:{
      deliveryOptions(){
          return this.group.available_settings.delivery
      },
      canOptimise(){
          return this.group.available_settings.optimise
      },
      deliveryInfo(){
          let item = this.group.available_settings.delivery.find(item => item.value == this.groupDelivery)

          if(item && 'info' in item){
              return item.info
          }
          return false
      }
  },
  watch:{
      groupOptimise(newVal, oldVal){
          if(oldVal === null){
            return;
          }
          //update on server
          this.$store.dispatch("cart/setGroupOptimise", {groupId: this.groupKey, optimise:newVal})
      },
      groupDelivery(newVal,oldVal){
        if(oldVal === null){
          return;
        }
        this.$store.dispatch("cart/setGroupDelivery", {groupId: this.groupKey, delivery:newVal})
      }
  }
};
</script>

<style lang="scss" scoped>
.freightGroup{
  border-bottom:3px grey dotted;
  padding-bottom:20px;
}

.heading{
  font-weight: bold;
}

label{
  width: auto;
}

.optimisecb{
  margin-left: 15px;
}

.freight_message{
  font-size: 0.9rem;
}

@include media-breakpoint-down(md){
  .optimisecb{
    margin-left: 0;
    position: absolute;
    top: 25px;
    right: 20px;
  }

  label{
    padding-right:10px;
  }

}

@include media-breakpoint-down(sm){
    label{
      padding-right: 20px;
    }
}

.default {
  font-weight: bold;
  color: $CTred;
}

.default option:not(.select) {
  color: #000;
  font-weight: normal;
}

</style>
